(function () {
  if (customElements.get("search-page")) return;

  class SearchPage extends HTMLElement {
    constructor() {
      super();
      this.moreContainer = null;
      this.searchUrl = "";
      this.sectionId = "";
      this.abortController = null;
    }

    connectedCallback() {
      this.moreContainer = this.querySelector("[data-search-more]");
      this.searchUrl = this.dataset.searchUrl || window.location.pathname;
      this.sectionId = this.dataset.sectionId || "";
      this.loadMoreResults();
      this.initPredictiveToggle();
    }

    initPredictiveToggle() {
      const predictiveResults = this.querySelector("[data-search-results]");
      const staticResults = this.querySelector("[data-search-static]");
      if (!predictiveResults || !staticResults) return;

      const observer = new MutationObserver(() => {
        const isPredictiveVisible =
          !predictiveResults.classList.contains("hidden");
        staticResults.classList.toggle("hidden", isPredictiveVisible);
      });

      observer.observe(predictiveResults, {
        attributes: true,
        attributeFilter: ["class"],
      });
    }

    async loadMoreResults() {
      if (!this.moreContainer) return;
      const params = new URLSearchParams(window.location.search);
      const query = params.get("q");
      if (!query) {
        this.moreContainer.classList.add("hidden");
        return;
      }

      if (this.abortController) {
        this.abortController.abort();
      }
      this.abortController = new AbortController();

      const url = new URL(this.searchUrl, window.location.origin);
      url.searchParams.set("q", query);
      url.searchParams.set("type", "collection,page,article");
      if (this.sectionId) {
        url.searchParams.set("section_id", this.sectionId);
      }

      try {
        this.moreContainer.classList.add("is-loading");
        if (!window.webvista?.fetchHtml) throw new Error("Search fetch failed");
        const doc = await window.webvista.fetchHtml(
          url.toString(),
          this.abortController.signal
        );
        const source = doc.querySelector("[data-search-more]");
        if (!source || !source.innerHTML.trim()) {
          this.moreContainer.classList.add("hidden");
          return;
        }

        this.moreContainer.innerHTML = source.innerHTML;
        this.moreContainer.classList.remove("hidden");

        if (window.webvista?.initLazyImageAnimation) {
          window.webvista.initLazyImageAnimation(this.moreContainer);
        }
        if (window.webvista?.initTooltips) {
          window.webvista.initTooltips(this.moreContainer);
        }
      } catch (error) {
        if (error.name === "AbortError") return;
        this.moreContainer.classList.add("hidden");
      } finally {
        this.moreContainer.classList.remove("is-loading");
      }
    }
  }

  customElements.define("search-page", SearchPage);
})();
